// Content Security Policy domains
export const CSP_DOMAINS = {
  scriptSrc: [
    "'self'",
    "'unsafe-inline'",
    'https://js.stripe.com',
    'https://data.concern.net',
    'https://data.concern.org.uk',
    'https://*.googletagmanager.com',
    'https://cdn.rollbar.com',
    'https://consent.cookiebot.com',
    'https://consentcdn.cookiebot.com',
    'https://ajax.googleapis.com',
    'https://translate.googleapis.com',
    'https://*.google.com',
    'https://*.gstatic.com',
    'https://widgets.sociablekit.com',
    'https://www.google.com/recaptcha/',
    'https://www.gstatic.com/recaptcha/',
    'https://www.paypal.com',
    'https://*.paypal.com',
    'https://*.paypalobjects.com',
    'https://translate.google.com',
    'https://cdn.fundraiseup.com',
    'https://static.fundraiseup.com',
    'https://connect.facebook.net',
  ],
  scriptSrcElem: [
    "'self'",
    "'unsafe-inline'",
    'https://pay.google.com',
    'https://cdn.fundraiseup.com',
    'https://static.fundraiseup.com',
    'https://www.paypal.com',
    'https://js.stripe.com',
    'https://translate-pa.googleapis.com',
    'http://translate.google.com',
    'https://translate.googleapis.com',
    'https://www.gstatic.com',
    'https://www.google.com',
    'https://consentcdn.cookiebot.com',
    'https://data.concern.net',
    'https://cdn.rollbar.com',
    'https://consent.cookiebot.com',
    'https://widgets.sociablekit.com',
    'https://ajax.googleapis.com',
    'https://www.googletagmanager.com',
    'https://connect.facebook.net',
    'https://cdn-4.convertexperiments.com',
  ],
  styleSrc: [
    "'self'",
    "'unsafe-inline'",
    'https://maxcdn.bootstrapcdn.com',
    'https://fonts.googleapis.com',
    'https://ajax.googleapis.com',
    'https://widgets.sociablekit.com',
    'https://www.gstatic.com',
  ],
  scriptSrcAttr: ["'self'", "'unsafe-inline'"],
};

/**
 * Builds the Content Security Policy string
 * @param {string} nonce - The nonce value to include in the CSP
 * @param {string} cspCentralEndpointId - The CSP Central Endpoint ID for reporting
 * @returns {string} The complete CSP string
 */
export const buildCSPString = (nonce, cspCentralEndpointId) => {
  const directives = [
    `frame-ancestors 'self'`,
    `script-src ${CSP_DOMAINS.scriptSrc.join(' ')} 'nonce-${nonce}'`,
    `style-src ${CSP_DOMAINS.styleSrc.join(' ')}`,
    `script-src-elem ${CSP_DOMAINS.scriptSrcElem.join(' ')}`,
    `script-src-attr ${CSP_DOMAINS.scriptSrcAttr.join(' ')}`,
    `worker-src 'self'`,
    `base-uri 'self'`,
    `form-action 'self'`,
    `report-uri https://report.centralcsp.com/${cspCentralEndpointId}`,
  ];

  return directives.join('; ');
};
